import React from "react";

function EncabezadoEvaluador() {
  return (
    <div>
      <div className="text-center">
        <div class="card-header py-3">
          <h5 class="m-0 font-weight-bold text-primary">
            ESPECIFICACIÓN ESQUEMA DE INFORME DE EVALUACION DE SEGUIMIENTO
            MODELO 3.1
          </h5>
        </div>
      </div>
      <div className="text-justify">
        <div class="table-responsive">
          <center>
            <table border={0}>
              <thead>
                <tr>
                  <div className="text-center">
                    <th>
                      <h6 class="m-0 font-weight-bold text-primary">
                        TABLA DE CONTENIDO
                      </h6>
                    </th>
                    <br></br>
                  </div>
                </tr>
              </thead>

              <tbody>
                <tr>
                  <td>
                    <h6>1. GENERALIDADES </h6>
                  </td>
                </tr>
                <tr>
                  <td>
                    <h6>2. OBJETIVOS DE LA EVALUACIÓN</h6>{" "}
                  </td>
                </tr>
                <tr>
                  <td>
                    <h6>3. REUNIÓN DE APERTURA</h6>
                  </td>
                </tr>
                <tr>
                  <td>
                    <h6>4. INFORMACIÓN INSTITUCIONAL</h6>
                  </td>
                </tr>
                <tr>
                  <td>
                    <h6> 5. AVANCES EN LOS EJES DE LA ACREDITACIÓN </h6>
                  </td>
                </tr>
                <tr>
                  <td>
                    <h6>
                      {" "}
                      6. FORTALEZAS, AVANCES Y DESARROLLOS DE LOS ESTÁNDARES
                      ASISTENCIALES
                    </h6>
                  </td>
                </tr>
                <tr>
                  <td>
                    <h6>
                      {" "}
                      7. FORTALEZAS, AVANCES Y DESARROLLOS DE LOS ESTÁNDARES DE
                      APOYO
                    </h6>
                  </td>
                </tr>
                <tr>
                  <td>
                    <h6>
                      8. TEMAS RELACIONADOS CON LA VOCACIÓN DEL SERVICIO PARA
                      AGREGAR VALOR
                    </h6>
                  </td>
                </tr>
                <tr>
                  <td>
                    <h6>
                      {" "}
                      9. ESTADO Y AVANCES DE LOS ESTANDARES DE MEJORAMIENTO
                      SISTEMICO DE LA CALIDAD
                    </h6>
                  </td>
                </tr>
                <tr>
                  <td>
                    <h6>10. REUNIÓN DE CIERRE</h6>
                  </td>
                </tr>
                <tr>
                  <td>
                    <h6>11. CALIFICACIÓN POR GRUPO DE ESTANDARES</h6>
                  </td>
                </tr>
              </tbody>
            </table>
          </center>
        </div>
      </div>
    </div>
  );
}

export default EncabezadoEvaluador;
